<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row data-cy="login-form">
      <fragment v-if="decryptedName && hasOldUserInfo">
        <v-col cols="12" class="mt-8 text-center justify-center">
          <v-avatar size="50" class="mb-2">
            <img :src="decryptedPhoto" alt="Foto do usuário" />
          </v-avatar>
          <p class="mb-7 details-policy__value primary--text">
            Não é você? Faça
            <BaseButton
              text
              @click="resetForm"
              v-html="'login'"
              color="secondary"
              class="body-2 font-weight-bold px-0 mt-n0"
              small
            />
            com outra conta.
          </p>
        </v-col>
        <v-col cols="12">
          <label class="mb-0 details-policy__value primary--text">
            Para continuar logado como
            <p class="mb-0 login__subtitle d-inline-block">
              {{ decryptedName }}
            </p>
            , insira a senha:
          </label>
          <BaseFormInput
            class="login__form-input"
            id-element="passwordLogin"
            placeholder="Senha"
            v-model="formLogin.password"
            cypress-id="password-login"
            type="password"
            required
            :rules="[requiredInput]"
            :upper-case="false"
            v-on:keyup.enter="submit()"
          />
        </v-col>
      </fragment>
      <fragment v-else>
        <v-col cols="12" class="mt-8">
        </v-col>
        <v-col cols="12" class="mt-5">
          <BaseFormInput
            class="login__form-input"
            id-element="usernameLogin"
            placeholder="usuario@email.com"
            v-model="formLogin.username"
            cypress-id="username-login"
            required
            :rules="[requiredInput]"
            :upper-case="false"
            v-on:keyup.enter="submit()"
            :readonly="isUserNewCotation"
          />
        </v-col>
        <v-col cols="12">
          <BaseFormInput
            class="login__form-input"
            id-element="passwordLogin"
            placeholder="Senha"
            v-model="formLogin.password"
            cypress-id="password-login"
            type="password"
            required
            :rules="[requiredInput]"
            :upper-case="false"
            v-on:keyup.enter="submit()"
          />
        </v-col>
      </fragment>
      <v-col cols="12">
        <BaseButton
          v-html="'Esqueceu a senha?'"
          color="secondary"
          class="body-2 font-weight-bold px-0 mt-n5"
          small
          text
          @click="$emit('show-forgot')"
        />
      </v-col>
      <v-col cols="12" class="my-8">
        <BaseButton
          v-html="'ENTRAR'"
          class="secondary font-weight-bold white--text"
          width="100%"
          :disabled="loading"
          @click="submit()"
          data-cy="submit-button"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { TokenService } from "@/api/storage.js";
export default {
  data: () => ({
    loading: false,
    formValid: true,
    formLogin: {
      client_id: "2f4a6b98-5715-4b73-95ab-466d3350f32c",
      grant_type: "password",
      username: "",
      password: "",
      refresh_token: ""
    },
    decryptedName: null,
    requiredInput
  }),
  props: {
    userEmail: {
      type: String
    }
  },
  mixins: [LoadingRequest],
  created() {
    this.updateFormLogin();
  },
  computed: {
    ...mapState("auth", ["routeWithoutToken"]),
    hasOldUserInfo() {
      return Boolean(TokenService.getUserInfo() && TokenService.getEmailInfo());
    },
    isUserNewCotation() {
      return this.userEmail != "" && this.userEmail != null;
    },
    userIsGuest() {
      return TokenService.getKeyInfo() == "00000000-0000-0000-0000-000000000000";
    },
    decryptedPhoto() {
      if (this.userIsGuest) {
        return;
      }

      var CryptoJS = require("crypto-js");
      var decrypted = CryptoJS.AES.decrypt(
        TokenService.getPhotoInfo(),
        TokenService.getKeyInfo()
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  },
  methods: {
    ...mapActions("auth", ["loginUser"]),
    ...mapActions("me", ["clearMyInfo"]),
    resetForm() {
      TokenService.removeInfo();
      this.formLogin.username = "";
      this.decryptedName = null;
    },
    updateFormLogin() {
      if (this.isUserNewCotation) {
        this.formLogin.username = this.userEmail;
        return;
      }

      if (!this.hasOldUserInfo || !this.decryptedPhoto) return;

      var CryptoJS = require("crypto-js");
      var decryptedEmail = CryptoJS.AES.decrypt(
        TokenService.getEmailInfo(),
        TokenService.getKeyInfo()
      );
      this.decryptedName = CryptoJS.AES.decrypt(
        TokenService.getUserInfo(),
        TokenService.getKeyInfo()
      );
      this.decryptedName = this.decryptedName.toString(CryptoJS.enc.Utf8);
      this.formLogin.username = decryptedEmail.toString(CryptoJS.enc.Utf8);
    },
    submit() {
      this.withLoading(
        this.loginUser(this.formLogin).then(response => {
          this.clearMyInfo();
          this.$router.push(this.getRoute(response));
        })
      );
    },
    getRoute(response) {
      return !response.user_info.accepted_terms
        ? { name: "term" }
        : this.routeWithoutToken || { name: "quotation" };
    }
  }
};
</script>
<style lang="sass">
.login
  &__subtitle
    font-size: 18px
    font-weight: 600
  &__form-input
    label.form__label.primary--text
      color: white !important
  &__logo
    display: block
    margin: 0 auto
</style>
